/** @jsxImportSource react */
import type { SVGProps } from 'react';
const BellOff = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.22 3.22a.75.75 0 0 1 1.06 0l16.5 16.5a.75.75 0 1 1-1.06 1.06L16.94 18h-1.19v.25a3.75 3.75 0 0 1-3.565 3.745L12 22a3.75 3.75 0 0 1-3.75-3.75V18h-4.5a.75.75 0 0 1-.53-1.28c.78-.78 1.22-1.205 1.514-1.648.34-.508.517-.813.517-1.322v-3.035a7.75 7.75 0 0 1 .98-3.423L3.22 4.28a.75.75 0 0 1 0-1.06m6.53 15.03A2.25 2.25 0 0 0 12 20.5l.223-.01a2.25 2.25 0 0 0 2.027-2.24V18h-4.5zM7.345 8.405a6.3 6.3 0 0 0-.594 2.368v2.977c0 .99-.413 1.62-.769 2.154a6 6 0 0 1-.463.596h9.92z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12 2a2.747 2.747 0 0 1 2.704 2.268 7.75 7.75 0 0 1 4.047 6.482v3a.75.75 0 0 1-1.5 0v-2.977a6.25 6.25 0 0 0-3.57-5.345.75.75 0 0 1-.43-.678 1.25 1.25 0 0 0-1.126-1.244L12 3.5a1.25 1.25 0 0 0-1.25 1.25.75.75 0 0 1-.43.678q-.305.144-.59.32a.75.75 0 0 1-.783-1.28q.171-.106.348-.201A2.75 2.75 0 0 1 12 2"
    />
  </svg>
);
export default BellOff;
